import { MenuProps } from 'components/Menu/Types'
import { Menu } from 'components/Menu/Menu'
import { Item, Section } from '@react-stately/collections'
import { Key } from 'react'
import { observer } from 'mobx-react-lite'
import { useAlmanacEditorState } from 'stores/EditorState'
import { SUPPORTED_FONTS } from 'prose-core'
import { FontFamilyType } from 'utils/fontUtils'
import { useFontFamily } from 'common/Prose/Toolbar/hooks/useFontFamily'
import { useFontWeight } from 'common/Prose/Toolbar/hooks/useFontWeight'

export const FontFamilySubMenu = observer(
  ({ onAction, menuType = 'dropdown' }: Pick<MenuProps<any>, 'menuType' | 'onAction'>) => {
    const editorState = useAlmanacEditorState()

    const { setFontFamily } = useFontFamily()
    const { setFontWeight } = useFontWeight()
    const { activeFamilies } = editorState || { activeFamilies: new Set<FontFamilyType>() }

    const handleAction = (action: Key) => {
      onAction?.(action)
      setFontFamily(action as FontFamilyType)
      setFontWeight('Regular')
    }

    return (
      <Menu
        onAction={handleAction}
        menuType={menuType}
        selectedKeys={activeFamilies}
        selectionMode="multiple"
        aria-label="Font Family"
      >
        <Section>
          {SUPPORTED_FONTS.map((fontName: FontFamilyType) => {
            return (
              <Item key={fontName} textValue={fontName}>
                <span
                  style={{
                    fontFamily: fontName,
                  }}
                >
                  {fontName}
                </span>
              </Item>
            )
          })}
        </Section>
      </Menu>
    )
  },
)
